
import { observer } from 'mobx-react';
import getMappingToolStore from '../data/MappingToolStore';
import { logDebug } from '../../../../shared/common/logger';

const MappingTicTypeSelector: React.FC<{ onSelect?: (type: string) => void }> = observer(({ onSelect}) => {
	const mappingStore = getMappingToolStore();
	const supportedTicTypes = mappingStore.supportedTicTypes;
	logDebug('rendering',mappingStore.ticType)
	return <div className="w-full h-[72px] px-14 justify-between items-center inline-flex">
		<div className="w-full h-[72px] justify-between items-center flex">
			<div className="grow shrink basis-0 h-[72px] border-b border-gray-200 flex-col justify-start items-start gap-2 inline-flex">
				<div className="grow shrink basis-0 justify-start items-end gap-8 inline-flex">
					{
						supportedTicTypes.map((ticType, index) => {
							return <div
								onClick={() => {
									if (onSelect) {
										onSelect(ticType);
									} else {
										location.href = `?ticType=${ticType}`;
									}
								}}
								key={index} className={`cursor-pointer w-[164px] self-stretch px-4 justify-center items-center gap-2 flex ${ticType === mappingStore.ticType ? 'border-blue-700 border-b-2' : ''}`}>
								<div className={`text-base font-semibold font-['Hanken Grotesk'] leading-normal ${ticType === mappingStore.ticType ? "text-blue-700" : 'text-gray-500 '}`}>{ticType}</div>

							</div>
						})
					}
				</div>
			</div>
			<div className="w-28 justify-end items-center gap-6 flex">
				<div className="justify-end items-center flex">
					<div className="w-11 h-11 p-3 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex">
						<div className="w-5 h-5 relative" />
					</div>
				</div>
				<div className="p-3 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex">
					<div className="w-5 h-5 relative" />
				</div>
			</div>
		</div>
	</div>
});

export default MappingTicTypeSelector;